<template>
  <div class="feedback-indicator m-t-30">
     <i class="fa fa-long-arrow-down vert-move" aria-hidden="true"></i> Please take a moment to leave us a feedback.
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>
  .feedback-indicator{
     font-size: 18px;
     font-weight: 500;
     color: rgb(20, 161, 255);
  }
  i.vert-move {
      -webkit-animation: mover 0.5s infinite  alternate;
      animation: mover 0.5s infinite  alternate;
      display: inline-block;
      font-size: 26px;
      color: rgb(255, 70, 70);
  }
  @-webkit-keyframes mover {
        0% { transform: translateY(0); }
        100% { transform: translateY(-10px); }
    }
    @keyframes mover {
        0% { transform: translateY(0); }
        100% { transform: translateY(-10px); }
    }

</style>